"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _Icon = _interopRequireDefault(require("./Icon.style"));

var _utils = _interopRequireDefault(require("../utils/utils"));

var _constants = require("../constants");

var _Actor = _interopRequireDefault(require("./img/Actor"));

var _ActorCard = _interopRequireDefault(require("./img/ActorCard"));

var _ActorGroup = _interopRequireDefault(require("./img/ActorGroup"));

var _ActorTime = _interopRequireDefault(require("./img/ActorTime"));

var _Add = _interopRequireDefault(require("./img/Add"));

var _Avatar = _interopRequireDefault(require("./img/Avatar"));

var _AddCard = _interopRequireDefault(require("./img/AddCard"));

var _AddColumn = _interopRequireDefault(require("./img/AddColumn"));

var _AddData = _interopRequireDefault(require("./img/AddData"));

var _AddItemBelow = _interopRequireDefault(require("./img/AddItemBelow"));

var _AddItemRow = _interopRequireDefault(require("./img/AddItemRow"));

var _AddMultiple = _interopRequireDefault(require("./img/AddMultiple"));

var _AddMultipleSquare = _interopRequireDefault(require("./img/AddMultipleSquare"));

var _AddSquare = _interopRequireDefault(require("./img/AddSquare"));

var _Aggregate = _interopRequireDefault(require("./img/Aggregate"));

var _AggregateMarkup = _interopRequireDefault(require("./img/AggregateMarkup"));

var _Alert = _interopRequireDefault(require("./img/Alert"));

var _Anonymous = _interopRequireDefault(require("./img/Anonymous"));

var _Api = _interopRequireDefault(require("./img/Api"));

var _Archive = _interopRequireDefault(require("./img/Archive"));

var _Arrow = _interopRequireDefault(require("./img/Arrow"));

var _ArrowReverse = _interopRequireDefault(require("./img/ArrowReverse"));

var _Arrows = _interopRequireDefault(require("./img/Arrows"));

var _ArrowStat = _interopRequireDefault(require("./img/ArrowStat"));

var _ArrowThin = _interopRequireDefault(require("./img/ArrowThin"));

var _Attach = _interopRequireDefault(require("./img/Attach"));

var _Bug = _interopRequireDefault(require("./img/Bug"));

var _Button = _interopRequireDefault(require("./img/Button"));

var _Calendar = _interopRequireDefault(require("./img/Calendar"));

var _Call = _interopRequireDefault(require("./img/Call"));

var _CallOff = _interopRequireDefault(require("./img/CallOff"));

var _NotificationOn = _interopRequireDefault(require("./img/NotificationOn"));

var _NotificationOff = _interopRequireDefault(require("./img/NotificationOff"));

var _Camera = _interopRequireDefault(require("./img/Camera"));

var _Channels = _interopRequireDefault(require("./img/Channels"));

var _Check = _interopRequireDefault(require("./img/Check"));

var _CheckBox = _interopRequireDefault(require("./img/CheckBox"));

var _CheckboxOff = _interopRequireDefault(require("./img/CheckboxOff"));

var _CheckboxOn = _interopRequireDefault(require("./img/CheckboxOn"));

var _Checklist = _interopRequireDefault(require("./img/Checklist"));

var _ChessBoard = _interopRequireDefault(require("./img/ChessBoard"));

var _Clock = _interopRequireDefault(require("./img/Clock"));

var _Close = _interopRequireDefault(require("./img/Close"));

var _CodeDone = _interopRequireDefault(require("./img/CodeDone"));

var _CodeFile = _interopRequireDefault(require("./img/CodeFile"));

var _CodeFind = _interopRequireDefault(require("./img/CodeFind"));

var _CodeInfo = _interopRequireDefault(require("./img/CodeInfo"));

var _CodeShare = _interopRequireDefault(require("./img/CodeShare"));

var _Coin = _interopRequireDefault(require("./img/Coin"));

var _Collapse = _interopRequireDefault(require("./img/Collapse"));

var _Comment = _interopRequireDefault(require("./img/Comment"));

var _Company = _interopRequireDefault(require("./img/Company"));

var _CompanyOffice = _interopRequireDefault(require("./img/CompanyOffice"));

var _Connection = _interopRequireDefault(require("./img/Connection"));

var _ContactUs = _interopRequireDefault(require("./img/ContactUs"));

var _Copy = _interopRequireDefault(require("./img/Copy"));

var _CopyCode = _interopRequireDefault(require("./img/CopyCode"));

var _CopyMultiple = _interopRequireDefault(require("./img/CopyMultiple"));

var _Currency = _interopRequireDefault(require("./img/Currency"));

var _Dashboard = _interopRequireDefault(require("./img/Dashboard"));

var _Dcircle = _interopRequireDefault(require("./img/Dcircle"));

var _Declined = _interopRequireDefault(require("./img/Declined"));

var _Decompose = _interopRequireDefault(require("./img/Decompose"));

var _Delete = _interopRequireDefault(require("./img/Delete"));

var _Diagram = _interopRequireDefault(require("./img/Diagram"));

var _Directions = _interopRequireDefault(require("./img/Directions"));

var _DifferentView = _interopRequireDefault(require("./img/DifferentView"));

var _Document = _interopRequireDefault(require("./img/Document"));

var _Dog = _interopRequireDefault(require("./img/Dog"));

var _Download = _interopRequireDefault(require("./img/Download"));

var _DownloadCircle = _interopRequireDefault(require("./img/DownloadCircle"));

var _Drag = _interopRequireDefault(require("./img/Drag"));

var _Dropdown = _interopRequireDefault(require("./img/Dropdown"));

var _EdgeCurved = _interopRequireDefault(require("./img/EdgeCurved"));

var _EdgeRounded = _interopRequireDefault(require("./img/EdgeRounded"));

var _Edit = _interopRequireDefault(require("./img/Edit"));

var _Editor = _interopRequireDefault(require("./img/Editor"));

var _Event = _interopRequireDefault(require("./img/Event"));

var _Exit = _interopRequireDefault(require("./img/Exit"));

var _Expand = _interopRequireDefault(require("./img/Expand"));

var _Export = _interopRequireDefault(require("./img/Export"));

var _ExportImport = _interopRequireDefault(require("./img/ExportImport"));

var _Eye = _interopRequireDefault(require("./img/Eye"));

var _File = _interopRequireDefault(require("./img/File"));

var _FileAdd = _interopRequireDefault(require("./img/FileAdd"));

var _FileLink = _interopRequireDefault(require("./img/FileLink"));

var _Files = _interopRequireDefault(require("./img/Files"));

var _Filter = _interopRequireDefault(require("./img/Filter"));

var _Fit = _interopRequireDefault(require("./img/Fit"));

var _Flag = _interopRequireDefault(require("./img/Flag"));

var _Flask = _interopRequireDefault(require("./img/Flask"));

var _Focus = _interopRequireDefault(require("./img/Focus"));

var _Form = _interopRequireDefault(require("./img/Form"));

var _FormPole = _interopRequireDefault(require("./img/FormPole"));

var _Folder = _interopRequireDefault(require("./img/Folder"));

var _FolderAdd = _interopRequireDefault(require("./img/FolderAdd"));

var _Func = _interopRequireDefault(require("./img/Func"));

var _FullScreenOn = _interopRequireDefault(require("./img/FullScreenOn"));

var _FullScreenOff = _interopRequireDefault(require("./img/FullScreenOff"));

var _Graph = _interopRequireDefault(require("./img/Graph"));

var _GraphTree = _interopRequireDefault(require("./img/GraphTree"));

var _Group = _interopRequireDefault(require("./img/Group"));

var _GroupSelection = _interopRequireDefault(require("./img/GroupSelection"));

var _Guest = _interopRequireDefault(require("./img/Guest"));

var _Hash = _interopRequireDefault(require("./img/Hash"));

var _Hide = _interopRequireDefault(require("./img/Hide"));

var _Hierarchy = _interopRequireDefault(require("./img/Hierarchy"));

var _History = _interopRequireDefault(require("./img/History"));

var _Import = _interopRequireDefault(require("./img/Import"));

var _Info = _interopRequireDefault(require("./img/Info"));

var _Json = _interopRequireDefault(require("./img/Json"));

var _Key = _interopRequireDefault(require("./img/Key"));

var _Lasso = _interopRequireDefault(require("./img/Lasso"));

var _Layer = _interopRequireDefault(require("./img/Layer"));

var _LayerAlign = _interopRequireDefault(require("./img/LayerAlign"));

var _LayerFilled = _interopRequireDefault(require("./img/LayerFilled"));

var _Link = _interopRequireDefault(require("./img/Link"));

var _LinkExternal = _interopRequireDefault(require("./img/LinkExternal"));

var _LinkedLayers = _interopRequireDefault(require("./img/LinkedLayers"));

var _List = _interopRequireDefault(require("./img/List"));

var _ListBulleted = _interopRequireDefault(require("./img/ListBulleted"));

var _LiveStream = _interopRequireDefault(require("./img/LiveStream"));

var _Location = _interopRequireDefault(require("./img/Location"));

var _Lock = _interopRequireDefault(require("./img/Lock"));

var _CleverLeaf = _interopRequireDefault(require("./img/CleverLeaf"));

var _Client = _interopRequireDefault(require("./img/Client"));

var _Mail = _interopRequireDefault(require("./img/Mail"));

var _MapMini = _interopRequireDefault(require("./img/MapMini"));

var _Maxsize = _interopRequireDefault(require("./img/Maxsize"));

var _Message = _interopRequireDefault(require("./img/Message"));

var _MessageHidden = _interopRequireDefault(require("./img/MessageHidden"));

var _Microphone = _interopRequireDefault(require("./img/Microphone"));

var _MicrophoneOff = _interopRequireDefault(require("./img/MicrophoneOff"));

var _Minimize = _interopRequireDefault(require("./img/Minimize"));

var _Minus = _interopRequireDefault(require("./img/Minus"));

var _More = _interopRequireDefault(require("./img/More"));

var _Move = _interopRequireDefault(require("./img/Move"));

var _MoveToTop = _interopRequireDefault(require("./img/MoveToTop"));

var _Multiply = _interopRequireDefault(require("./img/Multiply"));

var _Mute = _interopRequireDefault(require("./img/Mute"));

var _NoEye = _interopRequireDefault(require("./img/NoEye"));

var _Note = _interopRequireDefault(require("./img/Note"));

var _Notification = _interopRequireDefault(require("./img/Notification"));

var _OutArrow = _interopRequireDefault(require("./img/OutArrow"));

var _Opacity = _interopRequireDefault(require("./img/Opacity"));

var _Page = _interopRequireDefault(require("./img/Page"));

var _PageContent = _interopRequireDefault(require("./img/PageContent"));

var _PageSmall = _interopRequireDefault(require("./img/PageSmall"));

var _Palette = _interopRequireDefault(require("./img/Palette"));

var _PanelView = _interopRequireDefault(require("./img/PanelView"));

var _Paragraph = _interopRequireDefault(require("./img/Paragraph"));

var _PersonAdd = _interopRequireDefault(require("./img/PersonAdd"));

var _Persons = _interopRequireDefault(require("./img/Persons"));

var _Pin = _interopRequireDefault(require("./img/Pin"));

var _Plan = _interopRequireDefault(require("./img/Plan"));

var _Plus = _interopRequireDefault(require("./img/Plus"));

var _Power = _interopRequireDefault(require("./img/Power"));

var _Process = _interopRequireDefault(require("./img/Process"));

var _Profile = _interopRequireDefault(require("./img/Profile"));

var _Quote = _interopRequireDefault(require("./img/Quote"));

var _QuestionMark = _interopRequireDefault(require("./img/QuestionMark"));

var _Radar = _interopRequireDefault(require("./img/Radar"));

var _RadioOff = _interopRequireDefault(require("./img/RadioOff"));

var _RadioOn = _interopRequireDefault(require("./img/RadioOn"));

var _Reject = _interopRequireDefault(require("./img/Reject"));

var _ReadAll = _interopRequireDefault(require("./img/ReadAll"));

var _Redo = _interopRequireDefault(require("./img/Redo"));

var _RemoveFrom = _interopRequireDefault(require("./img/RemoveFrom"));

var _Repeat = _interopRequireDefault(require("./img/Repeat"));

var _Script = _interopRequireDefault(require("./img/Script"));

var _Search = _interopRequireDefault(require("./img/Search"));

var _SearchFilled = _interopRequireDefault(require("./img/SearchFilled"));

var _Send = _interopRequireDefault(require("./img/Send"));

var _Snippet = _interopRequireDefault(require("./img/Snippet"));

var _Settings = _interopRequireDefault(require("./img/Settings"));

var _Share = _interopRequireDefault(require("./img/Share"));

var _SideView = _interopRequireDefault(require("./img/SideView"));

var _Sign = _interopRequireDefault(require("./img/Sign"));

var _SkewGraph = _interopRequireDefault(require("./img/SkewGraph"));

var _Smile = _interopRequireDefault(require("./img/Smile"));

var _SortAsc = _interopRequireDefault(require("./img/SortAsc"));

var _SortDesc = _interopRequireDefault(require("./img/SortDesc"));

var _StarEmpty = _interopRequireDefault(require("./img/StarEmpty"));

var _StarFull = _interopRequireDefault(require("./img/StarFull"));

var _Stream = _interopRequireDefault(require("./img/Stream"));

var _Sum = _interopRequireDefault(require("./img/Sum"));

var _Tag = _interopRequireDefault(require("./img/Tag"));

var _Text = _interopRequireDefault(require("./img/Text"));

var _Textfield = _interopRequireDefault(require("./img/Textfield"));

var _Transaction = _interopRequireDefault(require("./img/Transaction"));

var _Transfer = _interopRequireDefault(require("./img/Transfer"));

var _Trash = _interopRequireDefault(require("./img/Trash"));

var _Picture = _interopRequireDefault(require("./img/Picture"));

var _Phone = _interopRequireDefault(require("./img/Phone"));

var _TypeGroup = _interopRequireDefault(require("./img/TypeGroup"));

var _TypeSingle = _interopRequireDefault(require("./img/TypeSingle"));

var _Undo = _interopRequireDefault(require("./img/Undo"));

var _Ungroup = _interopRequireDefault(require("./img/Ungroup"));

var _Unlink = _interopRequireDefault(require("./img/Unlink"));

var _Unpin = _interopRequireDefault(require("./img/Unpin"));

var _User = _interopRequireDefault(require("./img/User"));

var _UserTime = _interopRequireDefault(require("./img/UserTime"));

var _Video = _interopRequireDefault(require("./img/Video"));

var _VideoMeeting = _interopRequireDefault(require("./img/VideoMeeting"));

var _VideoOff = _interopRequireDefault(require("./img/VideoOff"));

var _Volume = _interopRequireDefault(require("./img/Volume"));

var _Wallet = _interopRequireDefault(require("./img/Wallet"));

var _Widget = _interopRequireDefault(require("./img/Widget"));

var _Trigger = _interopRequireDefault(require("./img/Trigger"));

var _TriggerHistory = _interopRequireDefault(require("./img/TriggerHistory"));

var _Textletter = _interopRequireDefault(require("./img/Textletter"));

var _dec, _class;

const __TYPES__ = {
  Actor: _Actor.default,
  ActorCard: _ActorCard.default,
  ActorGroup: _ActorGroup.default,
  ActorTime: _ActorTime.default,
  Add: _Add.default,
  Avatar: _Avatar.default,
  AddCard: _AddCard.default,
  AddColumn: _AddColumn.default,
  AddData: _AddData.default,
  AddItemBelow: _AddItemBelow.default,
  AddItemRow: _AddItemRow.default,
  AddMultiple: _AddMultiple.default,
  AddMultipleSquare: _AddMultipleSquare.default,
  AddSquare: _AddSquare.default,
  Aggregate: _Aggregate.default,
  AggregateMarkup: _AggregateMarkup.default,
  Alert: _Alert.default,
  Anonymous: _Anonymous.default,
  Api: _Api.default,
  Archive: _Archive.default,
  Arrow: _Arrow.default,
  ArrowReverse: _ArrowReverse.default,
  Arrows: _Arrows.default,
  ArrowStat: _ArrowStat.default,
  ArrowThin: _ArrowThin.default,
  Attach: _Attach.default,
  Bug: _Bug.default,
  Button: _Button.default,
  Calendar: _Calendar.default,
  Call: _Call.default,
  CallOff: _CallOff.default,
  NotificationOn: _NotificationOn.default,
  NotificationOff: _NotificationOff.default,
  Camera: _Camera.default,
  Channels: _Channels.default,
  Check: _Check.default,
  CheckBox: _CheckBox.default,
  CheckboxOff: _CheckboxOff.default,
  CheckboxOn: _CheckboxOn.default,
  Checklist: _Checklist.default,
  ChessBoard: _ChessBoard.default,
  Clock: _Clock.default,
  Close: _Close.default,
  CodeDone: _CodeDone.default,
  CodeFile: _CodeFile.default,
  CodeFind: _CodeFind.default,
  CodeInfo: _CodeInfo.default,
  CodeShare: _CodeShare.default,
  Coin: _Coin.default,
  Collapse: _Collapse.default,
  Comment: _Comment.default,
  Company: _Company.default,
  CompanyOffice: _CompanyOffice.default,
  Connection: _Connection.default,
  EdgeCurved: _EdgeCurved.default,
  EdgeRounded: _EdgeRounded.default,
  ContactUs: _ContactUs.default,
  Copy: _Copy.default,
  CopyCode: _CopyCode.default,
  CopyMultiple: _CopyMultiple.default,
  Currency: _Currency.default,
  Dashboard: _Dashboard.default,
  Dcircle: _Dcircle.default,
  Declined: _Declined.default,
  Decompose: _Decompose.default,
  Delete: _Delete.default,
  Diagram: _Diagram.default,
  Directions: _Directions.default,
  DifferentView: _DifferentView.default,
  Document: _Document.default,
  Dog: _Dog.default,
  Download: _Download.default,
  DownloadCircle: _DownloadCircle.default,
  Drag: _Drag.default,
  Dropdown: _Dropdown.default,
  Edit: _Edit.default,
  Editor: _Editor.default,
  Event: _Event.default,
  Exit: _Exit.default,
  Expand: _Expand.default,
  Export: _Export.default,
  ExportImport: _ExportImport.default,
  Import: _Import.default,
  Eye: _Eye.default,
  File: _File.default,
  FileAdd: _FileAdd.default,
  FileLink: _FileLink.default,
  Files: _Files.default,
  Filter: _Filter.default,
  Fit: _Fit.default,
  Flag: _Flag.default,
  Flask: _Flask.default,
  Focus: _Focus.default,
  Folder: _Folder.default,
  FolderAdd: _FolderAdd.default,
  Form: _Form.default,
  FormPole: _FormPole.default,
  Func: _Func.default,
  FullScreenOn: _FullScreenOn.default,
  FullScreenOff: _FullScreenOff.default,
  Graph: _Graph.default,
  GraphTree: _GraphTree.default,
  Group: _Group.default,
  GroupSelection: _GroupSelection.default,
  Guest: _Guest.default,
  Hash: _Hash.default,
  Hide: _Hide.default,
  Hierarchy: _Hierarchy.default,
  History: _History.default,
  Info: _Info.default,
  Json: _Json.default,
  Key: _Key.default,
  Lasso: _Lasso.default,
  Layer: _Layer.default,
  LayerAlign: _LayerAlign.default,
  LayerFilled: _LayerFilled.default,
  Link: _Link.default,
  LinkExternal: _LinkExternal.default,
  LinkedLayers: _LinkedLayers.default,
  List: _List.default,
  ListBulleted: _ListBulleted.default,
  LiveStream: _LiveStream.default,
  Location: _Location.default,
  Lock: _Lock.default,
  CleverLeaf: _CleverLeaf.default,
  Client: _Client.default,
  Mail: _Mail.default,
  MapMini: _MapMini.default,
  Maxsize: _Maxsize.default,
  Message: _Message.default,
  MessageHidden: _MessageHidden.default,
  Microphone: _Microphone.default,
  MicrophoneOff: _MicrophoneOff.default,
  Minimize: _Minimize.default,
  Minus: _Minus.default,
  More: _More.default,
  Move: _Move.default,
  MoveToTop: _MoveToTop.default,
  Multiply: _Multiply.default,
  Mute: _Mute.default,
  NoEye: _NoEye.default,
  Note: _Note.default,
  Notification: _Notification.default,
  OutArrow: _OutArrow.default,
  Opacity: _Opacity.default,
  Page: _Page.default,
  PageContent: _PageContent.default,
  PageSmall: _PageSmall.default,
  Palette: _Palette.default,
  PanelView: _PanelView.default,
  Paragraph: _Paragraph.default,
  PersonAdd: _PersonAdd.default,
  Persons: _Persons.default,
  Picture: _Picture.default,
  Phone: _Phone.default,
  Pin: _Pin.default,
  Plan: _Plan.default,
  Plus: _Plus.default,
  Power: _Power.default,
  Process: _Process.default,
  Profile: _Profile.default,
  Quote: _Quote.default,
  Radar: _Radar.default,
  RadioOff: _RadioOff.default,
  RadioOn: _RadioOn.default,
  Reject: _Reject.default,
  ReadAll: _ReadAll.default,
  Redo: _Redo.default,
  RemoveFrom: _RemoveFrom.default,
  Repeat: _Repeat.default,
  Script: _Script.default,
  Search: _Search.default,
  SearchFilled: _SearchFilled.default,
  Send: _Send.default,
  Snippet: _Snippet.default,
  StarEmpty: _StarEmpty.default,
  StarFull: _StarFull.default,
  Stream: _Stream.default,
  Sum: _Sum.default,
  Settings: _Settings.default,
  Share: _Share.default,
  SideView: _SideView.default,
  Sign: _Sign.default,
  SkewGraph: _SkewGraph.default,
  Smile: _Smile.default,
  SortAsc: _SortAsc.default,
  SortDesc: _SortDesc.default,
  QuestionMark: _QuestionMark.default,
  Tag: _Tag.default,
  Text: _Text.default,
  Textfield: _Textfield.default,
  Transaction: _Transaction.default,
  Transfer: _Transfer.default,
  Trash: _Trash.default,
  Trigger: _Trigger.default,
  TriggerHistory: _TriggerHistory.default,
  TypeGroup: _TypeGroup.default,
  TypeSingle: _TypeSingle.default,
  TextLetter: _Textletter.default,
  Undo: _Undo.default,
  Ungroup: _Ungroup.default,
  Unlink: _Unlink.default,
  Unpin: _Unpin.default,
  User: _User.default,
  UserTime: _UserTime.default,
  Video: _Video.default,
  VideoOff: _VideoOff.default,
  VideoMeeting: _VideoMeeting.default,
  Volume: _Volume.default,
  Wallet: _Wallet.default,
  Widget: _Widget.default
};
let Icon = (_dec = (0, _reactJss.default)(_Icon.default), _dec(_class = class Icon extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      instanceId: _utils.default.random(),
      color: null
    });
  }

  static getDerivedStateFromProps(props, state) {
    const {
      color
    } = props;
    const {
      instanceId,
      color: colorState
    } = state;
    if (typeof window === 'undefined') return null;

    if (color !== colorState) {
      const curEl = document.getElementById(instanceId);
      if (curEl) curEl.parentNode.removeChild(curEl);
      const styleEl = document.createElement('style');
      styleEl.id = instanceId;
      document.head.appendChild(styleEl);
      const sheet = styleEl.sheet;
      sheet.insertRule(`.IconMW-${instanceId} .fill {fill: ${color}!important}`, 0);
      sheet.insertRule(`.IconMW-${instanceId} .stroke {stroke: ${color}!important}`, 0);
      return {
        instanceId,
        color
      };
    }

    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    /**
     * There is a problem with icons re-rendering because of
     * heavy SVG rendering, so the decision was made to ignore
     * callback props changes.
     *
     * Warning: In the next MW-style-react version, remove callback
     * props from the Icon component to avoid potential bugs.
     * Therefore, the Icon component would serve only as a UI
     * element without interactions.
     */
    if (nextProps.color !== this.props.color || nextProps.type !== this.props.type || nextProps.size !== this.props.size || nextProps.visibility !== this.props.visibility || nextProps.error !== this.props.error || nextProps.className !== this.props.className || nextProps.colorType !== this.props.colorType || nextState.color !== this.state.color) {
      return true;
    }

    return false;
  }

  componentWillUnmount() {
    const {
      instanceId
    } = this.state;
    const styleEl = document.getElementById(instanceId);
    if (styleEl) styleEl.parentNode.removeChild(styleEl);
  }

  render() {
    const {
      type
    } = this.props;

    const IconComp = __TYPES__[_utils.default.toPascalCase(type)];

    const {
      classes,
      size,
      className,
      id,
      onClick,
      onMouseEnter,
      onMouseLeave,
      error,
      visibility,
      forwardRef,
      colorType,
      dataTestId
    } = this.props;
    const {
      instanceId
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("i", {
      id: id,
      className: (0, _clsx.default)(className, classes.wrap, classes[size]),
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      ref: forwardRef,
      "data-testid": dataTestId
    }, IconComp ? /*#__PURE__*/_react.default.createElement(IconComp, {
      className: (0, _clsx.default)(classes[size], classes.icon, classes[`fill__${colorType}`], `IconMW-${instanceId}`, {
        error: !!error
      }, {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      })
    }) : '');
  }

}) || _class);
Icon.COLOR = _constants.COLOR;
Icon.defaultProps = {
  size: 'medium',
  visibility: 'visible',
  error: false,
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {}
};
var _default = Icon;
exports.default = _default;